<div class="row">
    <div [ngClass]="'p-0 col-lg-' + cardSize" *ngFor="let stop of orderStops">
        <div class="standard-card">
            <div class="row">
                <div class="col-lg-6">
                    <h3>{{stop.reportDescription}}</h3>
                </div>
                <div class="col-lg-6 text-end">
                    <i class="fas fa-2x"
                       [ngClass]="{'text-success fa-check-circle': stop.arrivedInd == true && stop.departedInd == true, 'text-warning fa-clock': isCurrentStop(stop), 'text-primary fa-arrow-circle-right': stop.arrivedInd != true || stop.departedInd != true}"
                       [title]="getIconTitle(stop)"
                       aria-hidden="true"></i>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <b>Location</b><br />
                    <b>{{stop.stopCustomer}}</b><br />
                    {{stop.cityStateZip}}
                </div>
                <div class="col-lg-6" *ngIf="stop.carrier != null">
                    <b>Carrier</b><br />
                    <b>{{stop.carrierCode}} - {{stop.carrier}}</b><br />
                    <span *ngIf="!isCustomer">{{stop.driver}}: {{stop.driverCell}}<br /></span>
                    <span *ngIf="!isCustomer"><b>CSR:</b> {{stop.csr}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <b>Planned:</b><br />
                    {{stop.earliestDate | date: 'M/dd HH:mm'}} - {{stop.latestDate | date: 'M/dd HH:mm'}}
                </div>
                <div class="col-lg-6">
                    <div *ngIf="stop.arrivedInd == true && stop.departedInd == true"><b>Actual:</b></div>
                    <div *ngIf="stop.arrivedInd != true || stop.departedInd != true"><b>Estimated:</b></div>
                    {{stop.arrivalDate | date: 'M/dd HH:mm'}} - {{stop.departDate | date: 'M/dd HH:mm'}}
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <b>Ref #</b><br />
                    <ul>
                        <li *ngFor="let refNum of getStopRefNumbers(stop.orderStopID)">
                            {{refNum.referenceType}} - {{refNum.value}}
                        </li>
                        <li *ngIf="stop.eventCode == 'LUL' && stop.podName != null && stop.podName.length > 1">
                            POD Name: {{stop.podName}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
